import { render, staticRenderFns } from "./ViewNetPlane.vue?vue&type=template&id=42022b5a&scoped=true&"
import script from "./ViewNetPlane.vue?vue&type=script&lang=js&"
export * from "./ViewNetPlane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42022b5a",
  null
  
)

export default component.exports